import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { TargetGroupItem } from '@composites/PDF/AgendaPdfContent/components/TargetGroups';
import { styles } from '../../styles';
import { stylesAwesome } from '@composites/PDF/AgendaPdfContent/components/EventAtGlance';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { styles as whoAttendsStyles } from '@composites/PDF/AgendaPdfContent/components/TargetGroups/styles';

interface TargetGroupsProps {
  event: PublicEventDetailsResponse;
}

const TargetGroups = ({ event }: TargetGroupsProps) => {
  const { t } = useTranslation();

  const targetGroupsItems = useMemo(
    () =>
      event?.website_content?.targetgroups
        ?.filter(e => e)
        ?.sort((a, b) => a.order - b.order)
        ?.reduce((acc, item) => {
          if (item.level === 0) {
            acc.push({
              title: item.label,
              icon: item.icon?.split('-')?.join('_'),
              content: [],
            });
          } else if (item.level === 1 && acc.length > 0) {
            acc[acc.length - 1].content.push({
              title: item.label,
              percentage: item.value,
            });
          }
          return acc;
        }, []) as TargetGroupItem[],
    [event?.website_content?.targetgroups]
  );

  return (
    <View>
      <View
        style={{ ...styles.rightSideBody, gap: 20, alignItems: 'flex-start' }}
      >
        <Text style={styles.bodyTitle}>{t('prospectus-title-3')}</Text>
        <Text style={styles.bodyTitle}>{t('prospectus-title-4')}</Text>
        <View style={styles.bodyLineBar} />
        <View style={styles.textSpace}>
          <Text style={styles.regularBodyText}>
            {t('who-attends-pdf-text-3')}
          </Text>
          <Text style={styles.regularBodyText}>
            {t('who-attends-pdf-text-4')}
          </Text>
          <Text style={styles.regularBodyText}>
            {t('who-attends-pdf-text-5')}
          </Text>
        </View>
      </View>

      <View style={whoAttendsStyles.targetGroupsWrapper}>
        {targetGroupsItems?.map(item => (
          <View key={item.title}>
            <View style={whoAttendsStyles.targetGroupsItem}>
              <View style={whoAttendsStyles.targetGroupsHeader}>
                <Text style={stylesAwesome.icon}>{'\uf6ff'}</Text>
                <Text style={whoAttendsStyles.boldText}>{item.title}</Text>
              </View>

              <View>
                {item.content.map((content, index) => (
                  <Text key={index} style={whoAttendsStyles.regularText}>
                    {content.title}: {content.percentage}%
                  </Text>
                ))}
              </View>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default TargetGroups;
